var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper',{scopedSlots:_vm._u([{key:"1",fn:function(ref){
var changeActiveStep = ref.changeActiveStep;
return [_c('send-phone',{on:{"submitted":function($event){return _vm.submitted($event, changeActiveStep)}}})]}},{key:"2",fn:function(){return [_c('send-code',{attrs:{"phone":_vm.phone}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }